import * as React from 'react';
import FormInput from '../FormInput/FormInput';
import FormField from '../FormField/FormField';
const FormFieldInput = ({ t, field, label, namespace, isOptional, dense, inline, ...props }) => (React.createElement(FormField, { t, field, label, namespace, isOptional, dense, inline },
    React.createElement(FormInput, { t, field, ...props })));
export default FormFieldInput;
